import { scoreBg, scoreColor } from "@/lib/constants";

export function ScoreRing({ score, size = 56 }) {
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  const stroke = score >= 80 ? "#10b981" : score >= 60 ? "#f59e0b" : "#f43f5e";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--border))" strokeWidth="4" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={stroke} strokeWidth="4"
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }} />
      </svg>
      <span className={`absolute font-mono font-bold ${scoreColor(score)}`} style={{ fontSize: size / 3.5 }}>{score}</span>
    </div>
  );
}

export function ScoreBar({ label, value, weight }) {
  return (
    <div data-testid={`score-bar-${label}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-muted-foreground capitalize">{label} <span className="opacity-60">· {Math.round(weight * 100)}%</span></span>
        <span className="text-xs font-mono font-semibold">{value}</span>
      </div>
      <div className="h-1.5 rounded-full bg-muted overflow-hidden">
        <div className={`h-full rounded-full ${scoreBg(value)}`} style={{ width: `${value}%`, transition: "width 0.5s ease" }} />
      </div>
    </div>
  );
}
